module.exports = __webpack_public_path__ + "static/media/pgn.4ab868f0.png";